import React from 'react';
import { CalendarIcon, ClockIcon } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
const appointments = [{
  id: '1',
  agency: '指南者留学',
  type: '名校精英计划咨询',
  date: '2026-05-10',
  time: '14:00',
  status: '待咨询'
}, {
  id: '2',
  agency: '环球教育',
  type: '美研选校评估',
  date: '2026-05-01',
  time: '10:00',
  status: '已完成'
}];
export function MyAppointments() {
  return <div className="bg-slate-50 min-h-screen pb-10" data-id="element-521">
      <PageHeader title="我的预约" data-id="element-522" />
      <div className="p-3 space-y-3" data-id="element-523">
        {appointments.map(a => <div key={a.id} className="bg-white rounded-2xl p-4" data-id="element-524">
            <div className="flex items-center justify-between mb-3" data-id="element-525">
              <div className="font-bold text-slate-800" data-id="element-526">{a.agency}</div>
              <div className={`text-xs font-semibold px-2 py-1 rounded ${a.status === '待咨询' ? 'bg-blue-50 text-blue-600' : 'bg-slate-100 text-slate-500'}`} data-id="element-527">
                {a.status}
              </div>
            </div>
            <div className="text-sm text-slate-600 mb-2" data-id="element-528">{a.type}</div>
            <div className="flex items-center gap-4 text-xs text-slate-500" data-id="element-529">
              <span className="flex items-center gap-1" data-id="element-530">
                <CalendarIcon size={14} data-id="element-531" /> {a.date}
              </span>
              <span className="flex items-center gap-1" data-id="element-532">
                <ClockIcon size={14} data-id="element-533" /> {a.time}
              </span>
            </div>
            {a.status === '待咨询' && <div className="mt-4 flex gap-2" data-id="element-534">
                <button className="flex-1 h-9 rounded-full border border-slate-300 text-slate-700 text-sm" data-id="element-535">
                  取消预约
                </button>
                <button className="flex-1 h-9 rounded-full bg-blue-600 text-white text-sm" data-id="element-536">
                  联系顾问
                </button>
              </div>}
          </div>)}
      </div>
    </div>;
}